// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {
  CRISPRGuide,
  CRISPRRegion,
  OffTargetSite,
  OffTargetExon,
  OnTargetSite,
} from 'constants/CRISPRConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export default {
  create(data: {
    analysis: string;
    start: number;
    end: number;
    guides: Array<CRISPRGuide>;
  }): JQueryPromise<CRISPRRegion> {
    return net.postJSON({url: '/1/api/crispr-regions/', data});
  },

  update(id: string, data: Partial<CRISPRRegion>): JQueryPromise<CRISPRRegion> {
    return net.patchJSON({url: `/1/api/crispr-regions/${id}`, data});
  },

  bulkUpdate(regions: Array<Partial<CRISPRRegion> & {regionId: string}>): JQueryPromise<{
    regions: {[id: string]: CRISPRRegion};
    errors: {[id: string]: string};
  }> {
    return net.postJSON({url: '/1/api/crispr-regions/actions/bulk-update', data: {regions}});
  },

  analyzeOffTarget(id: string): JQueryPromise<CRISPRRegion> {
    return TaskRunner.runTask({
      url: `/1/api/crispr-regions/${id}/actions/analyze-off-target`,
      method: 'POST',
    });
  },

  analyzeOnTarget(regionIds: Array<string>): JQueryPromise<{[regionId: string]: OnTargetSite}> {
    return net.postJSON({
      url: '/1/api/crispr-regions/actions/analyze-on-target',
      data: {regionIds},
    });
  },

  matchExons(id: string, sites: Array<OffTargetSite>): JQueryPromise<{data: Array<OffTargetExon | null>}> {
    return net.postJSON({
      url: `/1/api/crispr-regions/${id}/actions/match-exons`,
      data: {sites},
    });
  },

  delete(id: string): JQueryPromise<{}> {
    return net.delete_({url: `/1/api/crispr-regions/${id}`});
  },
};
